const componentsComboboxDeviceCatalogComboboxEn = {
  noCatalogsFound: 'No catalogs found',
  searchCatalogPlaceholder: 'Search device catalog'
};
export default componentsComboboxDeviceCatalogComboboxEn;